import './plausible.directive';



// WEBPACK FOOTER //
// ./src/app/common/directives/directives.js